// extracted by mini-css-extract-plugin
export default {"backButtonContainer":"style_backButtonContainer__skyQ7","backButton":"style_backButton__j4+Je","img":"style_img__jte-R","title":"style_title__bqhnm"};